<template>
  <div class="g-sider">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GSider'
}
</script>

<style scoped>
.g-sider {}
</style>
